import { rfqSliceActions } from '@src/components/OMS/NewRFQ/RFQSlice';
import { openView } from '@src/components/OMS/OMSSlice';
import { OMSView } from '@src/components/OMS/OMSView';
import { useDefaultSubAccount } from '@src/hooks/useDefaultSubAccount';
import { useTradingSettings } from '@src/providers/AppConfigProvider';
import { useAppStateDispatch } from '@src/providers/AppStateProvider';
import { MixpanelEvent, OrdTypeEnum, useMixpanel, useSecuritiesContext } from '@talos/kyoko';
import { useCallback } from 'react';

export function usePrimePredictionRFQ() {
  const dispatch = useAppStateDispatch();
  const mixpanel = useMixpanel();
  const { securitiesBySymbol } = useSecuritiesContext();
  const { defaultSubAccount } = useDefaultSubAccount();
  const { enableDefaultMarketCardSubAccount } = useTradingSettings();

  return useCallback(
    ({
      symbol,
      orderQty,
      marketAccounts,
      aggregation,
      subAccount,
    }: {
      symbol: string;
      orderQty?: string;
      marketAccounts?: string[];
      aggregation?: string;
      subAccount?: string;
    }) => {
      const security = securitiesBySymbol.get(symbol);
      if (!security) {
        return;
      }

      mixpanel.track(MixpanelEvent.OpenRfqForm);
      dispatch(openView(OMSView.RFQForm));
      dispatch(
        rfqSliceActions.primeNewRFQForm({
          symbol,
          orderQty,
          ordType: OrdTypeEnum.LimitAllIn,
          currency: security.BaseCurrency,
          marketAccounts,
          aggregation,
          subAccount: enableDefaultMarketCardSubAccount && subAccount ? subAccount : defaultSubAccount?.Name,
        })
      );
    },
    [defaultSubAccount?.Name, dispatch, enableDefaultMarketCardSubAccount, mixpanel, securitiesBySymbol]
  );
}
